var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _mask, _path2, _path3, _mask2, _path4, _path5, _circle8, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntermediarie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 139,
    viewBox: "0 0 203 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.856,
    cy: 79.7788,
    r: 6.00486,
    fill: "#949EB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0389 50.3232C48.0389 48.1141 49.8297 46.3232 52.0389 46.3232H172.714C174.923 46.3232 176.714 48.1141 176.714 50.3232V54.9016H193.302C195.512 54.9016 197.302 56.6925 197.302 58.9016V68.0583C197.302 70.2675 195.512 72.0583 193.302 72.0583H164.131C159.476 76.015 158.931 82.8649 162.496 87.4994H198.449C200.659 87.4994 202.449 89.2903 202.449 91.4994V100.656C202.449 102.865 200.659 104.656 198.449 104.656H157.268C151.996 109.138 151.996 117.331 157.268 121.813H186.44C188.649 121.813 190.44 123.604 190.44 125.813V134.97C190.44 137.179 188.649 138.97 186.44 138.97H7.43135C5.22221 138.97 3.43135 137.179 3.43135 134.97V125.813C3.43135 123.604 5.22221 121.813 7.43135 121.813H21.1615C26.4339 117.331 26.4339 109.138 21.1615 104.656H4.00001C1.79087 104.656 0 102.865 0 100.656V91.4994C0 89.2903 1.79086 87.4994 4 87.4994H140.685L140.685 72.0583H17.7254C15.5162 72.0583 13.7254 70.2675 13.7254 68.0583V58.9016C13.7254 56.6925 15.5162 54.9016 17.7254 54.9016H48.0389V50.3232ZM133.823 104.656L133.823 121.813H44.6075V104.656H133.823Z",
    fill: "#F1F3F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.4898,
    cy: 12.0098,
    r: 5.14702,
    fill: "#949EB9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.7399,
    cy: 36.8868,
    r: 4.28918,
    fill: "#E93A4D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.96,
    cy: 13.7253,
    r: 3.43135,
    fill: "#949EB9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.656,
    cy: 3.43135,
    r: 3.43135,
    fill: "#E93A4D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.263,
    cy: 27.4509,
    r: 3.43135,
    fill: "#E93A4D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5979,
    cy: 80.6364,
    r: 3.43135,
    fill: "#E93A4D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_200_1058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.92 103.826L78.0044 85.7832L51.4707 119.482L73.5419 115.024L74.3862 137.526L51.4706 119.483L51.4704 119.483L74.3861 137.526L100.92 103.826Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.92 103.826L78.0044 85.7832L51.4707 119.482L73.5419 115.024L74.3862 137.526L51.4706 119.483L51.4704 119.483L74.3861 137.526L100.92 103.826Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0044 85.7832L80.4789 82.6405L77.3362 80.166L74.8616 83.3087L78.0044 85.7832ZM100.92 103.826L104.063 106.301L106.537 103.158L103.395 100.684L100.92 103.826ZM51.4707 119.482L48.3279 117.008L41.596 125.558L52.2626 123.403L51.4707 119.482ZM73.5419 115.024L77.5391 114.874L77.3627 110.172L72.7499 111.103L73.5419 115.024ZM74.3862 137.526L71.9117 140.668L78.7077 146.019L78.3834 137.376L74.3862 137.526ZM51.4706 119.483L53.9451 116.34L50.8023 113.865L48.3278 117.008L51.4706 119.483ZM51.4704 119.483L48.3277 117.008L45.8532 120.151L48.9959 122.625L51.4704 119.483ZM74.3861 137.526L71.9116 140.669L75.0543 143.143L77.5288 140L74.3861 137.526ZM75.5299 88.9259L98.4456 106.969L103.395 100.684L80.4789 82.6405L75.5299 88.9259ZM54.6134 121.957L81.1471 88.2577L74.8616 83.3087L48.3279 117.008L54.6134 121.957ZM52.2626 123.403L74.3339 118.945L72.7499 111.103L50.6787 115.562L52.2626 123.403ZM69.5447 115.174L70.389 137.676L78.3834 137.376L77.5391 114.874L69.5447 115.174ZM76.8607 134.383L53.9451 116.34L48.9961 122.625L71.9117 140.668L76.8607 134.383ZM54.6132 121.957L54.6133 121.957L48.3278 117.008L48.3277 117.008L54.6132 121.957ZM76.8606 134.383L53.9449 116.34L48.9959 122.625L71.9116 140.669L76.8606 134.383ZM97.7773 101.352L71.2434 135.051L77.5288 140L104.063 106.301L97.7773 101.352Z",
    fill: "#2B2B45",
    mask: "url(#path-9-inside-1_200_1058)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-2_200_1058",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.701 87.4993L109.803 100.915L129.532 139L129.532 139L134.589 117.059L155.429 125.585L155.43 125.585L135.701 87.4993Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.701 87.4993L109.803 100.915L129.532 139L129.532 139L134.589 117.059L155.429 125.585L155.43 125.585L135.701 87.4993Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.803 100.915L107.963 97.3628L104.412 99.2026L106.251 102.754L109.803 100.915ZM135.701 87.4993L139.253 85.6594L137.413 82.1077L133.861 83.9475L135.701 87.4993ZM129.532 139L125.98 140.84L127.82 144.392L131.371 142.552L129.532 139ZM129.532 139L131.372 142.552L133.014 141.701L133.43 139.898L129.532 139ZM134.589 117.059L136.104 113.356L131.749 111.574L130.692 116.16L134.589 117.059ZM155.429 125.585L153.915 129.287L155.627 129.987L157.269 129.137L155.429 125.585ZM155.43 125.585L157.27 129.136L160.821 127.297L158.981 123.745L155.43 125.585ZM111.643 104.466L137.541 91.051L133.861 83.9475L107.963 97.3628L111.643 104.466ZM133.083 137.16L113.355 99.0747L106.251 102.754L125.98 140.84L133.083 137.16ZM127.692 135.448L127.692 135.448L131.371 142.552L131.372 142.552L127.692 135.448ZM133.43 139.898L138.487 117.957L130.692 116.16L125.634 138.101L133.43 139.898ZM133.075 120.761L153.915 129.287L156.944 121.883L136.104 113.356L133.075 120.761ZM153.59 122.033L153.59 122.033L157.269 129.137L157.27 129.136L153.59 122.033ZM132.15 89.3391L151.878 127.425L158.981 123.745L139.253 85.6594L132.15 89.3391Z",
    fill: "#2B2B45",
    mask: "url(#path-11-inside-2_200_1058)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.94,
    cy: 72.058,
    r: 39.1762,
    fill: "white",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.94 49.3637L107.587 63.6632L108.036 65.0451H109.489H124.524L112.36 73.8826L111.185 74.7367L111.634 76.1187L116.28 90.4181L104.116 81.5806L102.94 80.7265L101.765 81.5806L89.601 90.4181L94.2472 76.1187L94.6962 74.7367L93.5206 73.8826L81.3568 65.0451H96.3921H97.8452L98.2942 63.6632L102.94 49.3637Z",
    fill: "#00BFA5",
    stroke: "#2B2B45",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntermediarie);
export default __webpack_public_path__ + "static/media/Intermediarie.c18f4d22c38bf0b7db19d87ed76c0ff4.svg";
export { ForwardRef as ReactComponent };